import $ from 'jquery';
import Unit from '../Global/_Unit.js';
export default class {

  static besePcW = 1365;
  // beseSpW = 375;
  static beseOpSpW = 500;
  static beseSpW = 375;

  static getOpPer() {
    const perW = Unit.isPc() ? this.besePcW : this.beseOpSpW;
    return $(window).width() / perW;
  }

  static getPer() {
    const perW = Unit.isPc() ? this.besePcW : this.beseSpW;
    return $(window).width() / perW;
  }

}
